<template>
	<div class="w-full flex flex-col pb-24 h-full">
		<div class="w-full flex flex-row items-center justify-around gap-4 text-2xl pb-8">
			<div class="w-full flex flex-row items-center justify-center gap-4 dark:text-stone-300 px-4">
				<div class="w-1/2 flex flex-col justify-center items-center">
					<div class="text-lg pb-2">Откуда</div>
					<select class="py-2 w-full border border-stone-900 rounded-2xl text-center dark:bg-stone-700" v-model="departure_city" @change="getActiveOffers">
						<option v-for="city, index in cities" :key="index" :value="city.name">{{ city.name }}</option>
					</select>
				</div>
				<!-- <div class="pt-8">
					<img :src="require('@/assets/arrow_right_90.png')" class="h-12"/>
				</div> -->
				<div class="w-1/2 flex flex-col justify-center items-center">
					<div class="text-lg pb-2">Куда</div>
					<select class="py-2 w-full border border-stone-900 rounded-2xl text-center dark:bg-stone-700" v-model="destination_city" @change="getActiveOffers">
						<option v-for="city, index in cities" :key="index" :value="city.name">{{ city.name }}</option>
					</select>
				</div>
			</div>
		</div>
		<div v-if="departure_city != null && destination_city != null" class="h-full">
			<div v-if="offers != null && offers.length > 0" class="w-full flex flex-col px-1">
				<div v-for="offer in offers" :key="offer.id" class="border dark:border-stone-700 rounded-lg overflow-hidden mb-8 bg-white dark:bg-stone-800">
					<div class="flex flex-col gap-1">
						<div class="flex flex-row justify-between pl-4 pt-4 pb-4 pr-8">
							<div class="flex flex-col gap-1 w-2/3">
								<div class="flex flex-row items-center">
									<img src="https://img.icons8.com/?size=256w&id=84&format=png" class="h-4 w-6 pr-2">
									{{ offer.departure_city }}
									{{ offer.departure_address }}
								</div>
								<div class="flex flex-row items-center">
									<img src="https://img.icons8.com/?size=256w&id=39803&format=png" class="h-4 w-6 pr-2">
									{{ offer.destination_city }}
									{{ offer.destination_address }}
								</div>
								<div class="flex flex-row items-center">
									<img src="https://img.icons8.com/?size=256w&id=VfeBw5ao3Irv&format=png" class="h-4 w-6 pr-2">
									<div class="flex flex-row items-center gap-1">
										{{ offer.price }}
										<div class="text-sm">₸</div>
									</div>
								</div>
								<div v-if="offer.comment.length > 0" class="flex flex-row items-center">
									<img src="https://img.icons8.com/?size=100&id=2951&format=png" class="h-4 w-6 pr-2">
									<div class="flex flex-row">
										{{ offer.comment }}
									</div>
								</div>
								<div class="flex flex-row items-center opacity-30">
									<img src="https://img.icons8.com/?size=256&id=10034&format=png" class="h-4 w-6 pr-2">
									<div>{{ offer.publish_at_formatted }}</div>
								</div>
								<div class="flex flex-row items-center">
									<img src="https://img.icons8.com/?size=512w&id=70151&format=png" class="h-4 w-6 pr-2">
									<div>Истекает через {{ formatTimer(offer.time_left) }}</div>
								</div>
								<div class="flex flex-row items-center opacity-50" @click="()=>{ selectOfferToReport(offer.id) }">
									<img src="https://img.icons8.com/?size=256w&id=1709&format=png" class="h-4 w-6 pr-2">
									<div class="text-rose-500 dark:text-rose-700">Пожаловаться</div>
								</div>
							</div>
							<div class="flex flex-col items-center justify-around border-l pl-4 w-1/3">
								<router-link v-if="this.$store.state.user === undefined" :to="{ name: 'Login'}" >
									<img class="h-16 w-16 bg-gray rounded-full p-2 m-2 bg-lime-300" src="https://img.icons8.com/?size=512w&amp;id=9730&amp;format=png">
								</router-link>
								<a v-else :href="`tel:${offer.login}`">
									<img class="h-16 w-16 bg-gray rounded-full p-2 m-2 bg-lime-300" src="https://img.icons8.com/?size=512w&amp;id=9730&amp;format=png">
								</a>
								<div class="flex flex-col items-center w-full">
									<div class="font-semibold">{{ offer.first_name }} {{ offer.last_name.substring(0,1) }}</div>
								</div>
							</div>
						</div>
						<div v-if="report.offer_id === offer.id" class="p-2 border-t">
							<div v-if="this.$store.state.user !== undefined">
								<div class="p-2 text-lg">Пожаловаться на объявление</div>
								<div class="p-2 text-lg flex flex-col items-center gap-2">
									<textarea class="rounded-md w-full p-2 border" v-model="report.comment" placeholder="Комментарий"></textarea>
									<input @click="()=>{sendOfferReport()}" type="submit" class="py-2 px-4 bg-rose-500 text-white rounded-md" />
								</div>
							</div>
							<div v-else>
								Для этого необходима авторизация
							</div>
						</div>
						<div class="flex flex-row items-center h-1 bg-stone-200 w-full">
							<div class="h-full bg-lime-500" :style="{'width': (offer.time_left * 100) / offer.expires_after +'%'}"></div>
						</div>
					</div>
				</div>
				<!-- <div class="h-48 bg-stone-300"></div> -->
			</div>
			<div v-else class="w-full flex flex-col justify-center items-center h-full">
				<img :src="require('@/assets/wavingman.png')" class="h-48 mb-16"/>
				<div v-if="serverErrors != null" class="text-3xl font-semibold text-center">{{ serverErrors }}</div>
				<div v-else class="text-3xl font-semibold">{{ loc('no_active_passenger_offers') }}</div>
			</div>
		</div>
		<!-- <div class="h-48 bg-stone-300"></div> -->
	</div>
</template>

<script>
// @ is an alias to /src

export default {
    name: 'DashboardHome',
    data () {
        return {
			is_loading: true,
			departure_city: '',
			destination_city: '',
            offers: [],
			offers_update_interval: null,
			report: {
				offer_id: null,
				comment: null 
			},
			cities: [],
			serverErrors: null
        }
    },
    methods: {
		sendOfferReport () {
			this.postServerData('reports_create', { data: { report_data: this.report, author_data: this.$store.state?.user  }}).then().finally(()=>{
				alert('Ваша жалоба отправлена')
			})
		},
		selectOfferToReport (uid) {
			this.report.comment = ''
			if (this.report.offer_id !== uid) this.report.offer_id = uid
			else this.report.offer_id = null
		},
		getCities () {
			this.getServerData('cities').then((res) => {
				res = res.data
				if(res.status != 404) {
					this.cities = res.data
				}
			})
		},
		getActiveOffers () {
			if (this.departure_city === '' || this.destination_city === '') return
			this.serverErrors = null
			this.getServerData('passenger_offers_active', [this.departure_city, this.destination_city]).then((res) => {
				res = res.data
				if(res.status == 403) {
					this.serverErrors = res.data
				}
				if(res.status == 200) {
					this.offers = res.data
				}
			})
		},
		timestampToDate (unix_timestamp) {
			let date = new Date(unix_timestamp * 1000)
			let hours = date.getHours();
			let minutes = "0" + date.getMinutes();
			let seconds = "0" + date.getSeconds();
			let formattedTime = hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);

			return formattedTime
		},
		formatTimer(seconds_left) {
			let mins = Math.floor(seconds_left / 60)
			let secs = Math.floor(seconds_left % 60)
			if (secs < 10) secs = '0' + secs
			let formattedTime = mins + ':' + secs
			return formattedTime
		}
	},
	mounted() {
		this.getCities()
		this.getActiveOffers()
		this.offers_update_interval = setInterval(()=> { this.getActiveOffers() }, 3000)
	},
	unmounted() {
		clearInterval(this.offers_update_interval)
	},

}
</script>
